import { tv, VariantProps } from "tailwind-variants"
import { AvatarBadgeSize, avatarBadgeVariants } from "../Avatar/avatar-badge"

export type TableSize = NonNullable<
  VariantProps<typeof tableRowSizeVariants>["size"]
>

type TableSizeValues = {
  rowHeight: number
  image: number
  badge?: AvatarBadgeSize
  gap: number
}

export const TABLE_SIZES: Record<TableSize, TableSizeValues> = {
  xs: {
    rowHeight: 24,
    image: 20,
    gap: 6,
  },
  sm: {
    rowHeight: 32,
    image: 24,
    gap: 4,
  },
  md: {
    rowHeight: 48,
    image: 32,
    badge: "xs",
    gap: 4,
  },
  lg: {
    rowHeight: 60,
    image: 40,
    badge: "sm",
    gap: 4,
  },
  xl: {
    rowHeight: 68,
    image: 48,
    badge: "md",
    gap: 4,
  },
  "2xl": {
    rowHeight: 76,
    image: 56,
    badge: "md",
    gap: 4,
  },
}

export const tableRowSizeVariants = tv({
  slots: {
    base: "",
    image: "rounded",
    text: "",
    badge: "",
    verifiedIcon: "shrink-0",
  },
  variants: {
    size: {
      xs: {
        base: "h-6 text-xs",
        image: "min-h-5 min-w-5",
        text: "text-xs",
        badge: avatarBadgeVariants({ size: "xs" }),
        verifiedIcon: "size-3.5",
      },
      sm: {
        base: "h-8 text-sm",
        image: "min-h-6 min-w-6",
        text: "text-sm",
        badge: avatarBadgeVariants({ size: "sm" }),
        verifiedIcon: "size-3.5",
      },
      md: {
        base: "h-12 text-sm",
        image: "min-h-8 min-w-8",
        text: "text-sm",
        badge: avatarBadgeVariants({ size: "sm" }),
        verifiedIcon: "size-3.5",
      },
      lg: {
        base: "h-[60px] text-sm",
        image: "min-h-10 min-w-10",
        text: "text-sm",
        badge: avatarBadgeVariants({ size: "sm" }),
        verifiedIcon: "size-4",
      },
      xl: {
        base: "h-[68px] text-md",
        image: "min-h-12 min-w-12",
        text: "text-md",
        badge: avatarBadgeVariants({ size: "md" }),
        verifiedIcon: "size-6",
      },
      "2xl": {
        base: "h-[76px] text-md",
        image: "min-h-14 min-w-14",
        text: "text-md",
        badge: avatarBadgeVariants({ size: "md" }),
        verifiedIcon: "size-6",
      },
    },
  },
})
